import axios from 'axios';
import authHeader from './AuthHeader';

import { get, isEmpty } from 'lodash';
import { URL_API } from '@configs/';
import { loadFromLocalStorageObjectFromBase64, saveToLocalStorage } from '@databases/localStorage';
import { contantAuthentication } from '@contants/';
import { showError } from '@components/notification';
import { useAuth } from '@hooks/useAuth';

const unauthorizedCode = [401];

const rootApi = axios.create({
  baseURL: URL_API,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  timeout: 30000
});

rootApi.interceptors.request.use(function (config) {
  let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
  if (!isEmpty(user)) {
    user = JSON.parse(user);
  }
  config.headers.Authorization = `Bearer ${user?.accessToken}`;
  return config;
});

rootApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const { response } = error;
    if (response && unauthorizedCode.includes(response.status)) {
      showError('Phiên đăng nhập hết hạn, vui lòng đăng nhập lại!');
      setTimeout(() => (window.location.href = '/account/signin'), 2000);
    }
    showError(error.response?.data.message || 'Vui lòng liên hệ admin để được hỗ trợ');
    return Promise.reject(error.response.data);
  }
);

export default rootApi;
